export default "__VITE_ASSET__Wy8ntvd6__"